import { DateInput, Stack, TextInput, useForm } from "@dutyon/ui-kit";

interface HolidayFormProps {
  formId: string;
  initialValues?: { name: string; date: Date | null };
  onSubmit: (values: { name: string; date: Date }) => void;
}

export function HolidayForm({ formId, initialValues, onSubmit }: HolidayFormProps) {
  const form = useForm({
    initialValues: initialValues || {
      name: "",
      date: null as Date | null,
    },
    validate: {
      name: (value) => {
        if (!value.trim()) return "공휴일 명을 입력해 주세요.";
        return null;
      },
      date: (value) => {
        if (!value) return "날짜를 선택해 주세요.";
        return null;
      },
    },
  });

  return (
    <form
      id={formId}
      onSubmit={form.onSubmit((values) => onSubmit(values as { name: string; date: Date }))}
      noValidate
    >
      <Stack gap="md">
        <TextInput
          label="공휴일 명"
          placeholder="예: 설날"
          maxLength={100}
          required
          {...form.getInputProps("name")}
        />
        <DateInput
          label="날짜"
          placeholder="날짜 선택"
          required
          locale="ko"
          valueFormat="YYYY년 MM월 DD일"
          {...form.getInputProps("date")}
        />
      </Stack>
    </form>
  );
}
